// ============================================
// 画像カルーセル（data-carousel="image"）
// ============================================
import Splide from '@splidejs/splide';

/**
 * data-carousel="image" のカルーセルを初期化
 */
export function initCarousel() {
	const carousels = document.querySelectorAll('[data-carousel="image"]');

	carousels.forEach((wrapper) => {
		const el = wrapper.querySelector('.splide');
		if (!el) return;

		new Splide(el, {
			type: 'fade',
			rewind: true,
			autoplay: true,
			interval: 6000,
			speed: 1000,
			pauseOnHover: false,
			arrows: false,
			pagination: true,
			focus: 'center',
		}).mount();
	});
}
